export default "__VITE_ASSET__C7$INWky__"